<template>
    <div class="form-group mb-3" :class="bsClass">
        <label :for="name" class="form-label" v-if="!labelHidden">
            {{ label }}
            <span class="text-danger" v-if="required"> *</span>
        </label>
        <input
            type="file"
            class="form-control"
            :id="name"
            @change="updateField"
            :ref="name"
            :accept="accepted"
            :required="required"
            :disabled="disabled"
            :multiple="multiple"
        >
        <span class="invalid-feedback" v-html="errorMessage()"></span>
        <span class="form-text text-muted mt-0" v-if="informationContent !== null">
        {{ informationContent }}
    </span>
    </div>
</template>

<script>
export default {
    name: "FormInputFile",
    props : {
        multiple : {
            type: Boolean,
            required: false,
            default: false
        },
        name : {
            type: String,
            required: true
        },
        label : {
            type: String,
            required: true
        },
        labelHidden : {
            type: Boolean,
            required: false,
            default: false
        },
        required : {
            type: Boolean,
            required: false,
            default: false
        },
        informationContent : {
            type: String,
            required: false,
            default: null
        },
        errors: {
            required: true
        },
        disabled : {
            type: Boolean,
            required: false,
            default: false
        },
        data: {
            required: false,
            default: null
        },
        bsClass: {
            type: String,
            required: false,
            default: "col-md-12"
        },
        accepted : {
            type: String,
            required: false,
            default: ""
        },
        resetFilenameAdded : {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            value: null,
            filenameAdded: null
        }
    },
    computed: {
        hasError() {
            return (
                this.errors &&
                this.errors[this.name] &&
                this.errors[this.name].length > 0
            )
        }
    },
    methods: {
        updateField: function() {
            this.clearErrors(this.name);
            if (this.multiple){
                this.value = this.$refs[this.name].files;
                this.filenameAdded = this.$refs[this.name].files.length + " fichiers ajoutés"
            } else {
                this.value = this.$refs[this.name].files[0];
                this.filenameAdded = this.$refs[this.name].files[0].name
            }
            this.$emit("update:field", this.value);
        },
        errorMessage: function() {
            if (this.hasError) {
                return this.errors[this.name][0];
            }
        },
        clearErrors: function() {
            if (this.hasError) {
                this.errors[this.name] = null;
            }
        },
        errorClassObject: function() {
            return {
                "is-invalid": this.hasError
            }
        }
    },
    watch: {
        resetFilenameAdded: {
            immediate: true,
            handler(newVal, oldVal) {
                if (this.resetFilenameAdded === true) this.filenameAdded = null;
            }
        }
    }
}
</script>

<style scoped>

</style>
